<template>
    <div class="Visitor"> 
        <a-scene
            class="Visitor__scene"
            xrextras-gesture-detector
            xrextras-almost-there
            xrextras-loading
            xrextras-runtime-error
            xrweb="disableWorldTracking: true">
            <a-assets>
                <video
                    id="alpha-video"
                    ref="movie"
                    autoplay
                    playsinline
                    muted
                    crossorigin="anonymous"
                    loop="true"
                    src="https://meneath-v2.dpt.media/static/overlay_green.mp4">
                    <!-- src="https://cdn.8thwall.com/web/assets/video/alpaca.mp4"> -->
                </video>
            </a-assets>
            <a-camera
                position="0 4 10"
                raycaster="objects: .cantap"
                cursor="fuse: false; rayOrigin: mouse;">
            </a-camera>
            <a-light type="directional" intensity="0.5" position="1 1 1"></a-light>
            <a-light type="ambient" intensity="1"></a-light>
            <a-entity
              target-video="name: f2; video: #alpha-video;"
              material="shader: chromakey; src: #alpha-video; color: 0.1 0.9 0.2"
              geometry="primitive: plane; height: 0.6; width: 1.38;">
            </a-entity>
        </a-scene>
        <div class="Visitor__header"> f2 - {{ time }} & {{ $id }} || {{ detected }}</div>
    </div>
</template>

<script>

import { Howl, Howler } from 'howler'

export default {

    name: 'Visitor',

    data: ()=>({
        time: 0,
        is_playing: false,
        sync: true,
        ready: false,
        delay: 1,
        loop: 0,
        detected: 'none'
    }),
   
    beforeDestroy() {
        this.$socket.emit('userLeaveRoom', this.$room)   
    },

    beforeCreate() {
        AFRAME.registerComponent('target-video', {
            schema: {
                name: { type: 'string' },
                video: {type: 'string' },
            },
            callback: (b)=> {
                this.onReady(b)
            },
            init: function () {
                const object3D = this.el.object3D
                      object3D.visible = false
                const name = this.data.name  
                const v = document.querySelector(this.data.video)
                const el = this.el
                const that = this
                const showImage = ({detail}) => {
                    if (name != detail.name) {
                        return
                    }
                    v.play()
                    object3D.position.copy(detail.position)
                    object3D.quaternion.copy(detail.rotation)
                    object3D.scale.set(detail.scale*.73, detail.scale*.73, detail.scale*.73)
                    object3D.visible = true
                    this.callback('true')
                }
                const hideImage = ({detail}) => {
                    if (name != detail.name) {
                        return
                    }
                    v.pause() 
                    object3D.visible = false
                    this.callback('false')
                }
                this.el.sceneEl.addEventListener('xrimagefound', showImage)
                this.el.sceneEl.addEventListener('xrimageupdated', showImage)
                this.el.sceneEl.addEventListener('xrimagelost', hideImage)
            }
        })
    },

    created(){ 
        this.$room = this.$route.params.room ? this.$route.params.room : 350
    },
    mounted() {
        this.$sound = new Howl({
            src: [require('@/commons/sound/sound.mp3')],
            // autoplay: true,
            loop: true,
            volume: 1
        })
        TweenMax.delayedCall(this.delay, ()=>{
            this.$refs.movie.muted = true
            this.$id = this.$sound.play()
            if(this.$socket.connected)
                this.$socket.emit('joinSession', this.$room, 'visitor')
      })
    },

    computed: {
        sync_time() { return this.$store.getters['socket/sync_time'] },
    },
    watch: {

        sync_time(nw, od) {
            // this.time = nw.time
            // const diff = Math.abs(nw.time - this.$refs.movie.currentTime)
            // const cue = nw.time + .2    
            // if(diff > 1) {
            //     this.$refs.movie.currentTime = cue
            //     this.$sound.seek(cue, this.$id)
            // }


            if(this.loop == 0) {
               
                const utc = Date.now()-nw.utc
                const adj = utc/1000
                const cue = nw.time + adj + .2  
  
                this.$refs.movie.currentTime = cue
                this.$sound.seek(cue, this.$id)
            }

            this.loop += 1
            if(this.loop ==10) 
                this.loop = 0


        },
    },

    methods: {

        onClick() {
            this.sync = false
            this.$refs.movie.play()
        },
        enter(done) {
            done()
            },
        leave(done) {
            done()
        },
        onReady(b) {
            this.detected = b
        },
        
    }

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Visitor
    overflow hidden
    position absolute
    width 100vw
    height 100%
    color white
    background white

    &__header 
        // opacity 
        // border 4px solid purple 
        width 90px
        height 30px
        top 8px
        left 8px
        position fixed
        z-index 10000

</style>